export default __webpack_public_path__ + "static/media/no_challenges.009b680c.png";